import { Font } from '@utmb/design-system/text/font';
import { IconsEnum } from '@utmb/types/icons';
import React from 'react';
import { Icon } from '../icons/Icon';
import styles from './my-utmb-points.module.scss';

interface MyUtmbPointsProps {
    size?: number;
    color: string;
    quantity: number;
}

const MyUtmbPoints = ({ size = 54, color, quantity }: MyUtmbPointsProps) => {
    return (
        <div className={styles.pointsContent}>
            <div className={styles.pointsBg}>
                <Icon variant={IconsEnum.MY_UTMB_POINTS} width={size} height={size} color={color} />
            </div>
            <Font.OxaniumRegular desktop={size <= 54 ? '16' : '30'} mobile={size <= 54 ? '16' : '26'} as="div" className={styles.pointsQuantity}>
                {quantity}
            </Font.OxaniumRegular>
        </div>
    );
};

export default MyUtmbPoints;
